<template>
  <div>
    <VHeader :user="user" />
    <TruckList :user="user" />
  </div>
</template>

<script>
import VHeader from "@/components/header";
import TruckList from "@/components/user/trucks/TrucksTable.vue";
import User from "@/models/User.js";

export default {
  data() {
    return {
      user: new User(this.$session.get("user")),
    };
  },
  created() {
    if (this.user.company_id == 9) {
      this.$session.destroy();
      this.$router.push("/login").catch(() => {});
    }
  },
  components: {
    VHeader,
    TruckList,
  },
};
</script>